import { getPref, Prefs, setPref } from '~/common/prefs';
import { useNewConflictSummaryEnabled } from './useNewConflictSummaryEnabled';

/** Which Conflicts Summary table UI the user last switched to. */
export type ConflictsSummaryView = 'new' | 'classic';

/** Stored view preference; anything but 'classic' resolves to 'new' (the flag-on default). */
export function getConflictsSummaryViewPref(): ConflictsSummaryView {
  return getPref(Prefs.CONFLICTS_SUMMARY_VIEW) === 'classic' ? 'classic' : 'new';
}

/** Persist the view the user switched to (New View / Classic View buttons only). */
export function setConflictsSummaryViewPref(view: ConflictsSummaryView) {
  setPref(Prefs.CONFLICTS_SUMMARY_VIEW, view);
}

/** Flag off always resolves to classic; the preference only applies while the flag is on. */
export function resolveConflictsSummaryPath(flagEnabled: boolean, view: ConflictsSummaryView) {
  return flagEnabled && view === 'new' ? '/conflictsSummaryV2' : '/conflictsSummary';
}

/** Link target for Conflicts Summary: the user's most recent view, defaulting to the new view when the flag is on. */
export function useConflictsSummaryPath() {
  const newConflictSummaryEnabled = useNewConflictSummaryEnabled();
  return resolveConflictsSummaryPath(newConflictSummaryEnabled, getConflictsSummaryViewPref());
}
